'use client';

import { useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './CreatePlaylistModal.module.css';

export default function CreatePlaylistModal({ onCreate, onClose }) {
  const [title, setTitle] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    onCreate(title.trim());
    onClose();
  };

  if (typeof window === 'undefined') return null;

  return createPortal(
    <div
      className={styles.overlay}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={styles.modal}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className={styles.heading}>New Playlist</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Enter playlist name"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className={styles.input}
            autoFocus
          />
          <div className={styles.actions}>
            <button
              type="submit"
              className={styles.confirm}
              onMouseDown={(e) => e.stopPropagation()}
            >
              Create
            </button>
            <button
              type="button"
              className={styles.cancel}
              onClick={onClose}
              onMouseDown={(e) => e.stopPropagation()}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
